<template>
<div>
    <wysiwyg v-if="content.type == 0" :content="content" :readOnly="readOnly" v-on:OnChangeContent="OnChangeContent">
    </wysiwyg>
    <datatable v-if="content.type == 1" :content="content" :readOnly="readOnly" v-on:OnChangeContent="OnChangeContent">
    </datatable>
    <keyfacts v-if="content.type == 2" :content="content" :readOnly="readOnly" v-on:OnChangeContent="OnChangeContent">
    </keyfacts>
</div>
</template>

<script>
import wysiwyg from './ADContent/wysiwyg.vue'
import datatable from './ADContent/datatable.vue'
import keyfacts from './ADContent/keyfacts.vue'

export default {
    
    name: "AssetDetailContent",
    components: {
        wysiwyg,
        datatable,
        keyfacts
    },
    data() {
        return {
           
        }
    },
    props: {
        //Content model, passed directly as a prop to the correct content type
        content: {
            default : null,
            type : Object
        },
        //Should this content be read only?
        readOnly: {
            default : false,
            type : Boolean
        }
    },
    methods:{
        OnChangeContent(uploadModel)
        {
            console.log("Upserting model");
            console.log(uploadModel);
            
            this.$emit("OnChangeContent",{id:  this.content.id, type : this.content.type, jsondata : JSON.stringify(uploadModel)});
        }
    },
}
</script> 